import axios from 'axios';
import {isEmpty, template} from 'lodash';

import {AppConfig} from '../../configs';
import {buildHttpRequestHeader} from '../../utils';

export const rqCreateMultipartRequest = (api, body, token, params, signal) => {
  return rqCreateRequest(
    api,
    body,
    token,
    params,
    signal,
    'multipart/form-data',
  );
};

export const rqCreateRequest = (
  api,
  body,
  token,
  params,
  signal,
  contentType = 'application/json',
  accept = 'application/json',
  filter = {},
) => {
  let url = api.url;
  if (params !== null && params !== undefined) {
    url = template(url)(params);
  }
  console.log(url);
  if (isEmpty(token)) {
    localStorage.getItem('token');
  }

  const headers = buildHttpRequestHeader({}, api.auth, token, contentType);

  if (filter && Object.keys(filter).length > 0) {
    const queryString = new URLSearchParams(filter).toString();
    url = `${url}?${queryString}`;
  }

  if (api.method === 'POST') {
    return axios
      .post(`${AppConfig.API_BASE_URL}/${url}`, body, {
        headers: headers,
        signal,
      })
      .then(response => response.data);
  } else if (api.method === 'PUT') {
    return axios
      .put(`${AppConfig.API_BASE_URL}/${url}`, body, {
        headers: headers,
        signal,
      })
      .then(response => response.data);
  } else {
    return axios({
      url: `${AppConfig.API_BASE_URL}/${url}`,
      method: api.method,
      headers: headers,
      signal,
    }).then(response => response.data);
  }
};
